import request from '@/api/request'

//发布众包
export function webCrowdAdd(data) {
    return request({
        url: '/web/crowd/add',
        method: 'POST',
        data
    })
}

//众包列表
export function webCrowdList(data) {
    return request({
        url: '/web/crowd/list',
        method: 'GET',
        params: data
    })
}

//众包详情
export function webCrowdInfo(data) {
    return request({
        url: '/web/crowd/info',
        method: 'GET',
        params: data
    })
}

//众包修改
export function webCrowdUpdate(data) {
    return request({
        url: '/web/crowd/update',
        method: 'POST',
       data
    })
}




//众包-选标/淘汰/中标
export function webCrowdBidUpdate(data) {
    return request({
        url: '/web/crowd/bid/update',
        method: 'POST',
       data
    })
}



//众包操作记录
export function webCrowdOperateList(data) {
    return request({
        url: '/web/crowd/operate/list',
        method: 'GET',
        params: data
    })
}


//众包投标
export function webCrowdBidAdd(data) {
    return request({
        url: '/web/crowd/bid/add',
        method: 'POST',
         data
    })
}

//众包我的投标列表
export function webCrowdBidList(data) {
    return request({
        url: '/web/crowd/bid/list',
        method: 'GET',
        params: data
    })
}

//众包我的投标详情
export function webCrowdBidInfo(data) {
    return request({
        url: '/web/crowd/bid/info',
        method: 'GET',
        params: data
    })
}

export function webCrowdIndexSearchList(data) {
    return request({
        url: '/web/crowd/index/search/list',
        method: 'GET',
        params: data
    })
}
//全部众包详情
export function webCrowdIndexInfo(data) {
    return request({
        url: '/web/crowd/index/info',
        method: 'GET',
        params: data
    })
}

export function webRecruitProjectList(data) {
    return request({
        url: '/web/recruit/project/list',
        method: 'GET',
        params: data
    })
}


